module.exports = __webpack_public_path__ + "img/anli6.3e502096.png";